// Traduções pt-BR. Idioma padrão / fonte de verdade das chaves.
// Mantenha en.ts com exatamente as mesmas chaves.
const pt = {
  common: {
    update: "Atualizar",
    loading: "Carregando dados…",
    viewAll: "Ver todas",
    manage: "Gerenciar",
    waiting: "Aguardando...",
    reading: "Lendo...",
    ok: "OK",
  },
  language: {
    label: "Idioma",
    pt: "Português",
    en: "Inglês",
  },
  theme: {
    light: "Tema claro",
    dark: "Tema escuro",
  },
  brand: {
    title: "Plataforma de Impressão",
  },
  nav: {
    sections: {
      operacao: "Operação",
      impressao: "Impressão",
      importacao: "Importação",
      gravacao: "Gravação",
      configuracao: "Configuração",
      ajuda: "Ajuda",
    },
    items: {
      inicio: "Início",
      etiquetas: "Etiquetas",
      conferirEtiqueta: "Conferir Etiqueta",
      logsImpressao: "Logs de Impressão",
      filaImpressao: "Fila de Impressão",
      impressaoAvulsa: "Impressão Avulsa",
      impressaoSscc: "Impressão SSCC",
      impressaoBipagem: "Impressão por Bipagem",
      reimprimirEtiqueta: "Reimprimir Etiqueta",
      importarPlanilha: "Importar Planilha",
      importarXml: "Importar XML",
      importarPedidos: "Importar Pedidos",
      importarOrdem: "Importar Ordem",
      gravacaoAvulsa: "Gravação Avulsa",
      serializacao: "Serialização",
      testadorModulo: "Testador de Módulo",
      perfilPreferencia: "Perfil de Preferência",
      preferencias: "Preferências",
      documentacao: "Documentação",
    },
    copyIds: "Copiar IDs (debug)",
    copyIdsTooltip: "Copiar IDs (conta, usuário e configuração)",
    idsCopied: "IDs copiados para a área de transferência",
  },
  routes: {
    login: "Login",
    inicio: "Início",
    etiquetas: "Etiquetas",
    editorEtiqueta: "Editor de Etiqueta",
    conferirEtiqueta: "Conferir Etiqueta",
    importarOrdem: "Importar Ordem",
    impressaoAvulsa: "Impressão Avulsa",
    gravacaoAvulsa: "Gravação Avulsa",
    reimprimirEtiqueta: "Reimprimir Etiqueta",
    importarPlanilha: "Importar Planilha",
    importarXml: "Importar XML",
    logsImpressao: "Logs de Impressão",
    filaImpressaoSocket: "Fila de Impressão Socket",
    serializacao: "Serialização",
    testadorModulo: "Testador de Módulo",
    importarPedidos: "Importar Pedidos",
    impressaoSscc: "Impressão SSCC",
    impressaoBipagem: "Impressão por Bipagem",
    perfilPreferencia: "Perfil de Preferência",
    preferencias: "Preferências",
    documentacao: "Documentação",
  },
  header: {
    moduleStatus: "Status do módulo",
    moduleStatusFull: "Status do módulo",
    moduleConfig: "Config. do módulo",
    moduleConfigFull: "Configurações do módulo",
    checkLabel: "Conferir etiqueta",
  },
  user: {
    admin: "Administrador",
    preferences: "Preferências",
    logout: "Sair",
    noName: "Sem nome",
  },
  auth: {
    heroTitle: "Plataforma de Impressão",
    heroSubtitle:
      "Gerencie suas etiquetas RFID com eficiência e controle total sobre o processo de impressão.",
    feature1: "Gravação e leitura RFID em tempo real",
    feature2: "Múltiplos perfis de impressão por hardware",
    feature3: "Logs e diagnóstico de ordens ao vivo",
    rightsReserved: "Todos os direitos reservados.",
  },
  dashboard: {
    greetingMorning: "Bom dia",
    greetingAfternoon: "Boa tarde",
    greetingEvening: "Boa noite",
    fallbackUser: "usuário",
    summary: "Aqui está um resumo da sua operação de impressão.",
    noProfile: "Sem perfil",
    profileTitle: "Perfil de impressão em uso",
    stats: {
      last7days: "Últimos 7 dias",
      ordersPrinted: "ordens impressas",
      successRate: "Taxa de sucesso",
      finished: "{{count}} finalizadas",
      failed: "Com falha",
      checkLogs: "verifique os logs",
      allGood: "tudo certo",
      currentQueue: "Fila atual",
      onePending: "ordem pendente",
      manyPending: "ordens pendentes",
    },
    statsError:
      "Não foi possível carregar todas as estatísticas. Tente atualizar novamente.",
    roll: {
      level: "Nível do rolo de etiquetas",
      ending: "Acabando",
      usedOf: "de",
      labelsUsed: "etiquetas usadas",
      remaining: "restantes",
    },
    quickActions: "Ações rápidas",
    actions: {
      impressaoAvulsaDesc: "Imprimir etiqueta unitária",
      importarPlanilhaDesc: "CSV ou Excel",
      importarXmlDesc: "Notas fiscais",
      importarPedidosDesc: "Ordens de fabricação",
      importarOrdemDesc: "Lista de ordens ativas",
      reimprimirEtiquetaDesc: "Repetir etiqueta existente",
      conferirEtiquetaDesc: "Validar leitura RFID",
      logsImpressaoDesc: "Histórico e diagnóstico",
    },
    recentPrints: "Últimas impressões",
    noRecentPrints: "Nenhuma impressão recente",
    labels: "etiquetas",
    printQueue: "Fila de impressão",
    queueEmpty: "Fila vazia",
    queueEmptyDesc: "Nada aguardando impressão",
    pending: "Pendente",
    andMore: "e mais {{count}}…",
    hardware: "Hardware",
    defaultLabel: "Etiqueta padrão",
  },
  login: {
    success: "Login realizado com sucesso!",
    invalidCredentials:
      "Usuário ou senha incorretos. Verifique as credenciais e tente novamente.",
    autoLoginFailed:
      "Não foi possível autenticar com o link informado. Faça o login manualmente.",
    authenticating: "Autenticando…",
    authenticatingDesc:
      "Aguarde um instante enquanto entramos com seu usuário.",
    welcome: "Bem-vindo de volta",
    subtitle: "Digite suas credenciais para acessar sua conta",
    userOrEmail: "Usuário ou E-mail",
    password: "Senha",
    forgotPassword: "Esqueceu a senha?",
    hidePassword: "Ocultar senha",
    showPassword: "Mostrar senha",
    capsLock: "Caps Lock está ativado",
    signingIn: "Entrando...",
    signIn: "Entrar",
    noAccount: "Não possui uma conta?",
    signUp: "Cadastre-se",
  },
  cadastro: {
    title: "Crie sua conta",
    subtitle: "Comece a gerenciar suas etiquetas RFID em poucos passos",
    sectionCompany: "Sobre a empresa",
    sectionAccess: "Seu acesso",
    companyName: "Nome da empresa",
    companyNamePlaceholder: "Ex: Acme Indústria Ltda",
    corporateEmail: "Email corporativo",
    corporateEmailPlaceholder: "contato@empresa.com",
    phone: "Telefone",
    cnpj: "CNPJ",
    optional: "(opcional)",
    fullName: "Nome completo",
    fullNamePlaceholder: "Seu nome completo",
    accessEmail: "Email de acesso",
    accessEmailPlaceholder: "voce@empresa.com",
    password: "Senha",
    passwordPlaceholder: "Mínimo 8 caracteres",
    confirmPassword: "Confirmar senha",
    confirmPasswordPlaceholder: "Repita a senha",
    capsLock: "Caps Lock está ativado",
    acceptTermsPrefix: "Li e aceito os",
    termsOfUse: "termos de uso",
    and: "e a",
    privacyPolicy: "política de privacidade",
    creating: "Criando conta...",
    submit: "Criar conta",
    haveAccount: "Já possui uma conta?",
    signIn: "Entrar",
    successTitle: "Cadastro realizado!",
    successDesc:
      "Sua conta foi criada com sucesso. Por questões de segurança, novas contas começam aguardando aprovação da nossa equipe de suporte.",
    nextSteps: "Próximos passos para liberar seu acesso",
    nextStep1: "Entre em contato com a nossa equipe de suporte",
    nextStep2Prefix: "Informe o email cadastrado:",
    backToLogin: "Voltar para o login",
    heroTitle: "Comece em minutos",
    heroSubtitle:
      "Crie sua conta agora e dê o primeiro passo para uma operação de impressão RFID mais inteligente.",
    errCompanyName: "Informe o nome da empresa.",
    errCompanyEmail: "Informe o email da empresa.",
    errEmailInvalid: "Email inválido.",
    errAdminName: "Informe o nome do administrador.",
    errAdminEmail: "Informe o email de acesso.",
    errPasswordRequired: "Crie uma senha.",
    errPasswordMin: "A senha deve ter ao menos 8 caracteres.",
    errConfirmRequired: "Confirme a senha.",
    errPasswordMismatch: "As senhas não coincidem.",
    errTerms: "Você precisa aceitar os termos.",
    errCompanyCreate: "Não foi possível criar a empresa.",
    errCompanyEmailInUse: "Este email já está em uso.",
    errAdminCreate: "Não foi possível criar o usuário administrador.",
    errAdminEmailInUse: "Este email já está cadastrado.",
    errCompanyCreatedUserFailed:
      "A empresa foi criada, mas houve um problema ao criar o usuário: {{msg}}. Entre em contato com o suporte.",
  },
  notFound: {
    code: "Erro 404",
    title: "Página não encontrada",
    description:
      "A página que você está procurando não existe, foi movida ou está indisponível no momento.",
    triedToAccess: "Você tentou acessar:",
    goBack: "Voltar",
    goHome: "Ir para o início",
  },
  common2: {
    save: "Salvar",
    cancel: "Cancelar",
    ok: "OK",
    sync: "Sincronizar",
    print: "Imprimir",
    notDefined: "Não definido",
    understood: "Entendi",
  },
  fila: {
    orderName: "Nome da Ordem",
    creationDate: "Data de Criação",
    actions: "Ações",
    resend: "Reenviar",
    remove: "Remover",
    title: "Fila de Impressão",
    clearQueue: "Limpar Fila",
    empty: "Nenhum item na fila de impressão.",
  },
  ajusteRolo: {
    success: "Rolo ajustado com sucesso!",
    error: "Erro ao ajustar o rolo. Tente novamente.",
    adjusting: "Ajustando o rolo, aguarde...",
    title: "Ajuste Automático de Rolo",
    module: "Módulo:",
    start: "Iniciar Ajuste",
    adjustAgain: "Ajustar Novamente",
    tryAgain: "Tentar Novamente",
  },
  perfilDialog: {
    title: "Configuração de Perfil do Módulo",
    description: "Configure os parâmetros do seu módulo de impressão",
  },
  serializacao: {
    codeEmpty: "Código não pode ficar vazio.",
    serialInvalid: "Serial deve ser um número maior ou igual a zero.",
    edit: "Editar",
    codeGtin: "Código (GTIN)",
    serial: "Serial",
    saveChanges: "Salvar alterações",
    syncSuccess: "Seriais sincronizados!",
    noSerialsToDelete: "Não há seriais para apagar.",
    allDeleted: "Todos os seriais foram apagados com sucesso.",
    deleteError: "Erro ao apagar alguns seriais. Tente novamente.",
    currentSerial: "Serial atual",
    actions: "Ações",
    delete: "Apagar",
    restrictedTitle: "Acesso restrito",
    restrictedDesc:
      "Apenas administradores podem acessar a página de serialização.",
    deleteAllConfirm:
      "Tem certeza que deseja apagar todos os seriais cadastrados? Esta ação não pode ser desfeita.",
    deleteAllTitle: "Apagar todos os seriais",
    deleteOneConfirm:
      "Tem certeza que deseja apagar este serial? Esta ação não pode ser desfeita.",
    deleteOneTitle: "Apagar serial",
    title: "Serialização",
    subtitle:
      "Controle o serial atual de cada GTIN (próximo número gerado na impressão)",
    deleteAll: "Apagar todos",
    noSerialsToDeleteTitle: "Não há seriais para apagar",
    registeredSerials: "Seriais cadastrados",
    codesCount_one: "{{count}} código",
    codesCount_other: "{{count}} códigos",
    noSerials: "Nenhum serial cadastrado",
    noSerialsDesc:
      "Os seriais aparecem aqui automaticamente após a primeira impressão de cada código.",
  },
  ordens: {
    syncSuccess: "Dados sincronizados com sucesso!",
    orderName: "Nome da ordem",
    actions: "Ações",
    print: "Imprimir",
    delete: "Apagar",
    deleteConfirm:
      "Tem certeza que deseja apagar esta ordem de impressão? Esta ação não pode ser desfeita.",
    deleteTitle: "Apagar ordem de impressão",
    selectAll: "Selecionar todas as ordens",
    selectOrder: "Selecionar ordem",
    deleteSelected: "Apagar selecionadas",
    deleteSelectedTitle: "Apagar ordens selecionadas",
    deleteSelectedConfirm_one:
      "Tem certeza que deseja apagar a ordem selecionada? Esta ação não pode ser desfeita.",
    deleteSelectedConfirm_other:
      "Tem certeza que deseja apagar as {{count}} ordens selecionadas? Esta ação não pode ser desfeita.",
    deleteAll: "Apagar todas",
    deleteAllTitle: "Apagar todas as ordens",
    deleteAllConfirm_one:
      "Tem certeza que deseja apagar a ordem disponível? Esta ação não pode ser desfeita.",
    deleteAllConfirm_other:
      "Tem certeza que deseja apagar todas as {{count}} ordens? Esta ação não pode ser desfeita.",
    title: "Importar Ordem",
    subtitle: "Ordens disponíveis para impressão vindas do ERP",
    sync: "Sincronizar",
    available: "Ordens disponíveis",
    ordersCount_one: "{{count}} ordem",
    ordersCount_other: "{{count}} ordens",
    noOrders: "Nenhuma ordem disponível",
    noOrdersDesc:
      'Quando o ERP enviar novas ordens, elas aparecerão aqui. Use "Sincronizar" pra checar.',
    viewJson: "JSON",
    jsonTitle: "JSON da ordem",
    copyJson: "Copiar JSON",
    jsonCopied: "JSON copiado para a área de transferência.",
    jsonCopyError: "Não foi possível copiar o JSON.",
    jsonError: "Erro ao coletar o JSON da ordem. Tente novamente mais tarde.",
    printedOrders: "Ordens impressas",
    printedOrdersTitle: "Ordens já marcadas como impressas",
    printedOrdersDesc:
      "Ordens que já foram impressas ou apagadas. Use o botão JSON para ver o conteúdo original.",
    noPrintedOrders: "Nenhuma ordem marcada como impressa",
    syncNow: "Sincronizar agora",
    configNotFound: "Configuração de impressão não encontrada.",
    selectLocation: "Selecione uma localização para impressão.",
    informHardwareId:
      "Informe o Hardware ID nas configurações para realizar a impressão.",
    fieldsNotConfigured:
      "Campos de impressão não configurados corretamente. Configure em Preferências.",
    errorCreatingCategory: "Erro ao criar categoria com código {{codigo}}.",
    noEpcGenerated: "Nenhum EPC gerado para impressão.",
    invalidEpcs:
      "EPCs inválidos encontrados. Verifique os dados e tente novamente.",
    errorCollecting: "Erro ao coletar dados da ordem. Tente novamente mais tarde.",
    codeField: "Código (Campo {{n}})",
    descField: "Descrição (Campo {{n}})",
    epcField: "EPC (Campo {{n}})",
    loc1Field: "Localização 1 (Campo {{n}})",
    loc2Field: "Localização 2 (Campo {{n}})",
    loc3Field: "Localização 3 (Campo {{n}})",
    loc4Field: "Localização 4 (Campo {{n}})",
    externalCodeField: "Código Externo (Campo {{n}})",
    field: "Campo {{n}}",
    notDefinedParen: "(Não definido)",
    repeatedEpcsFound: "EPCs repetidos encontrados",
    repeatedEpcsDesc:
      'Os EPCs abaixo já existem na base. Sincronize os dados e tente novamente, ou ative "Permitir repetidos" para imprimir mesmo assim.',
    noOrderName: "Nome da ordem não fornecido",
    noOrderNameDesc: "Volte para a lista e selecione uma ordem para visualizar.",
    backToList: "Voltar para lista",
    loadingOrder: "Carregando ordem",
    backToListTitle: "Voltar para lista",
    itemsInOrder_one: "{{count}} item na ordem",
    itemsInOrder_other: "{{count}} itens na ordem",
    helpTooltip:
      'Para definir o código e a descrição dos itens, acesse "Preferências" e depois clique em "Ordem (Socket)".',
    allowRepeated: "Permitir repetidos",
    noItemsToPrint: "Sem itens pra imprimir",
    selectALocation: "Selecione uma localização",
    printNLabels_one: "Imprimir {{count}} etiqueta",
    printNLabels_other: "Imprimir {{count}} etiquetas",
    codesConverted:
      "{{count}} código(s) com caracteres fora do padrão hexadecimal foram convertidos automaticamente.",
    codesConvertedDesc:
      "O código original vem da ordem, mas o EPC será gerado com o código convertido.",
    locations: "Localizações",
    level1: "Nível 1",
    level2: "Nível 2",
    level3: "Nível 3",
    level4: "Nível 4",
    orderItems: "Itens da ordem",
    itemsCount_one: "{{count}} item",
    itemsCount_other: "{{count}} itens",
  },
  planilha: {
    ean: "EAN",
    description: "Descrição",
    value: "Valor",
    quantity: "Quantidade",
    expiry: "Dt. Validade",
    location1: "Localização 1",
    location2: "Localização 2",
    location3: "Localização 3",
    location4: "Localização 4",
    infoCompl: "Inf. compl. {{n}}",
    notArray: "O dado não é um array.",
    rowNotObject: "Item na linha {{n}} não é um objeto válido.",
    requiredFieldsMissing:
      "Campos obrigatórios ausentes ou vazios na planilha: {{details}}.",
    fieldOnLines: '"{{field}}" na(s) linha(s) {{lines}}',
    andMore: "e mais {{n}}",
    requiredByEpc:
      "Os campos {{fields}} entram na montagem do EPC configurado para esta conta, então precisam estar preenchidos nas linhas sem TAG.",
    headerAssumed: "Planilha sem linha de cabeçalho",
    headerAssumedDesc:
      "Nenhuma coluna conhecida foi encontrada na primeira linha, então as colunas foram assumidas na ordem do modelo oficial:",
    tagMustBeString: 'Campo "TAG" deve ser string na linha {{n}}.',
    onlyCsv: "Apenas arquivos .csv são aceitos.",
    importSuccess: "Planilha importada com sucesso!",
    noFileSelected: "Nenhum arquivo selecionado.",
    syncSuccess: "Dados sincronizados com sucesso!",
    noItemsToPrint: "Nenhum item na planilha para gerar impressão.",
    configNotFound: "Configuração de impressão não encontrada.",
    informHardwareId:
      "Informe o Hardware ID nas configurações para realizar a impressão.",
    reverseWithTags:
      "Não é possível imprimir com gravação reversa e TAGs. Por favor, remova as TAGs da planilha.",
    categoryNotFoundBase: "Categoria com EAN {{ean}} não encontrada na base.",
    location1Missing: "Localização 1 não informada ou inválida para o item {{n}}.",
    nv2NotLinked:
      'Localização NV2 "{{desc}}" não está vinculada a uma localização NV1 válida.',
    nv3NotLinked:
      'Localização NV3 "{{desc}}" não está vinculada a uma localização NV2 válida.',
    nv4NotLinked:
      'Localização NV4 "{{desc}}" não está vinculada a uma localização NV3 válida.',
    categoryNotFound: "Categoria com EAN {{ean}} não encontrada.",
    noEpcGenerated: "Nenhum EPC gerado para impressão.",
    invalidEpcs:
      "EPCs inválidos encontrados. Verifique os dados e tente novamente.",
    title: "Importar Planilha",
    subtitle: "Envie um CSV com itens e gere etiquetas em lote",
    examples: "Exemplos",
    downloadModel: "Baixar modelo de CSV",
    items: "Itens",
    withoutTag: "sem TAG",
    withTag: "com TAG",
    importToPrint: "Importe uma planilha pra imprimir",
    printNLabels_one: "Imprimir {{count}} etiqueta",
    printNLabels_other: "Imprimir {{count}} etiquetas",
    importCsvFile: "Importar arquivo CSV",
    dropHere: "Solte o arquivo aqui",
    dragOrClick: "Arraste o CSV ou clique para selecionar",
    acceptsOnly: "Aceita apenas arquivos",
    useExamples: "· use os exemplos como modelo",
    fileLoaded: "Arquivo carregado",
    itemImported_one: "{{count}} item importado",
    itemImported_other: "{{count}} itens importados",
    clear: "Limpar",
    codesConverted:
      "{{count}} código(s) com caracteres fora do padrão hexadecimal foram convertidos automaticamente.",
    codesConvertedDesc:
      "O código original é mantido na planilha para exibição, mas o EPC será gerado com o código convertido.",
    sheetItems: "Itens da planilha",
    itemsCount_one: "{{count}} item",
    itemsCount_other: "{{count}} itens",
    repeatedEpcsFound: "EPCs repetidos encontrados",
    repeatedEpcsDesc:
      'Os EPCs abaixo já existem na base. Sincronize os dados e tente novamente, ou ative "Permitir repetidos" para imprimir mesmo assim.',
  },
  xml: {
    code: "Código",
    codeField: "Código ({{campo}})",
    description: "Descrição",
    descField: "Descrição ({{campo}})",
    descBase: "Descrição (base)",
    info: "Info {{n}}",
    withSource: "{{label}} ({{campo}})",
    withBase: "{{label}} (base)",
    value: "Valor",
    valueField: "Valor ({{campo}})",
    validity: "Validade",
    validityField: "Validade ({{campo}})",
    codeFieldNotConfigured:
      "Campo Código XML não configurado. Configure em Preferências > XML.",
    invalidXml: "Arquivo XML inválido: {{erro}}",
    processErrorGeneric: "Erro ao processar o arquivo XML.",
    noElementFound:
      'Nenhum elemento com campo "{{campo}}" encontrado no XML. Verifique a configuração em Preferências > XML.',
    noValidItem: "Nenhum item com código válido encontrado no XML.",
    someWithoutDesc:
      '{{count}} item(s) sem descrição encontrado(s). Verifique o campo "Campo Descrição" nas configurações XML.',
    categoriesNotFound:
      "Não foi encontrada uma categoria válida na base para o(s) código(s) informado(s): {{codigos}}",
    importSuccessN: "{{count}} item(ns) importado(s) com sucesso!",
    importedItems: "Itens importados",
    onlyXml: "Apenas arquivos .xml são aceitos.",
    noProducts: "Nenhum produto encontrado no XML.",
    noFileSelected: "Nenhum arquivo selecionado.",
    syncSuccess: "Dados sincronizados com sucesso!",
    noItemsToPrint: "Nenhum item para gerar impressão.",
    configNotFound: "Configuração de impressão não encontrada.",
    informHardwareId:
      "Informe o Hardware ID nas configurações para realizar a impressão.",
    categoryNotFound: "Categoria com EAN {{ean}} não encontrada.",
    noEpcGenerated: "Nenhum EPC gerado para impressão.",
    invalidEpcs:
      "EPCs inválidos encontrados. Verifique os dados e tente novamente.",
    title: "Importar XML",
    subtitle: "Importe os itens de uma NF-e (arquivo .xml)",
    importToPrint: "Importe um XML pra imprimir",
    printNLabels_one: "Imprimir {{count}} etiqueta",
    printNLabels_other: "Imprimir {{count}} etiquetas",
    importXmlFile: "Importar arquivo XML",
    dropHere: "Solte o arquivo aqui",
    dragOrClick: "Arraste o XML ou clique para selecionar",
    acceptsOnly: "Aceita apenas arquivos",
    ofNfe: "de NF-e",
    fileLoaded: "Arquivo carregado",
    itemImported_one: "{{count}} item importado",
    itemImported_other: "{{count}} itens importados",
    clear: "Limpar",
    xmlItems: "Itens do XML",
    itemsCount_one: "{{count}} item",
    itemsCount_other: "{{count}} itens",
    repeatedEpcsFound: "EPCs repetidos encontrados",
    repeatedEpcsDesc:
      'Os EPCs abaixo já existem na base. Sincronize os dados e tente novamente, ou ative "Permitir repetidos" para imprimir mesmo assim.',
  },
  ui: {
    search: "Pesquisar...",
    noResults: "Nenhum resultado encontrado.",
    noData: "Nenhum dado encontrado",
    previous: "Anterior",
    next: "Próximo",
    page: "Página",
    of: "de",
    loading: "Carregando...",
    selectColumn: "Selecione uma coluna",
    selectColumnAria: "Selecione uma coluna para filtrar",
    filterValue: "Valor do filtro",
    clearFilters: "Limpar Filtros",
    firstPage: "Primeira página",
    previousPage: "Página anterior",
    nextPage: "Próxima página",
    lastPage: "Última página",
    sureTitle: "Você tem certeza?",
    sureDesc:
      "Essa ação não poderá ser desfeita. Isso vai apagar permanentemente os dados.",
    cancel: "Cancelar",
    confirm: "Confirmar",
  },
  loader: {
    syncing: "Sincronizando...",
    syncingSlow:
      "Sincronizando... (pode demorar mais um pouco dependendo do tamanho dos dados)",
    syncingStill: "Ainda sincronizando... Aguarde mais alguns instantes.",
    syncingLong:
      "Sincronizando... (isso está levando mais tempo que o normal, verifique sua conexão)",
    syncingContactSupport:
      "Sincronizando... (se você acha que está demorando demais, por favor, entre em contato com o suporte técnico)",
  },
  avulsa: {
    qty: "Qtd:",
    val: "Val:",
    assign: "+ Atribuir",
    quantity: "Quantidade",
    valueBrl: "Valor (R$)",
    validity: "Validade",
    save: "Salvar",
    zplNotConfigured: "ZPL não configurado",
    preview: "Pré-visualizar",
    previewAlt: "Pré-visualização",
    openInNewTab: "Abrir em nova aba",
    descCodeRequired: "Descrição e código são obrigatórios.",
    codeConverted: "Código convertido para hexadecimal: {{original}} → {{novo}}",
    categoryCreated: "Categoria criada com sucesso!",
    categoryCreateError: "Erro ao criar categoria.",
    syncSuccess: "Dados sincronizados com sucesso!",
    selectCategory: "Selecione uma categoria para impressão.",
    configNotFound: "Configuração de impressão não encontrada.",
    informHardwareId:
      "Informe o Hardware ID nas configurações para realizar a impressão.",
    selectLocation: "Selecione uma localização para impressão.",
    noEpcGenerated: "Nenhum EPC gerado para impressão.",
    invalidEpcs:
      "EPCs inválidos encontrados. Verifique os dados e tente novamente.",
    individualInfo: "Informação individual",
    previewCol: "Pré-visualização",
    infoCompl: "Info. Complementar {{n}}",
    title: "Impressão Avulsa",
    subtitle: "Imprima etiquetas RFID a partir de uma categoria",
    showMore: "Mostrar mais infos",
    allowRepeated: "Permitir repetidos",
    sync: "Sincronizar",
    selectCategoryLocationToPrint:
      "Selecione uma categoria e localização para imprimir",
    printNLabels_one: "Imprimir {{count}} etiqueta",
    printNLabels_other: "Imprimir {{count}} etiquetas",
    print: "Imprimir",
    category: "Categoria",
    categoryAndQuantity: "Categoria e quantidade",
    selectACategory: "Selecione uma categoria",
    noCategoryFound: "Nenhuma categoria encontrada.",
    newCategory: "Nova categoria",
    searchByDescOrCode:
      "Buscar por descrição, código ou info. complementar...",
    newCategoryTitle: "Criar nova categoria",
    quantityLabel: "Quantidade",
    locations: "Localizações",
    level1: "Nível 1",
    level2: "Nível 2",
    level3: "Nível 3",
    level4: "Nível 4",
    description: "Descrição",
    labels: "Etiquetas",
    generatedLabels: "Etiquetas geradas",
    labelsCount_one: "{{count}} etiqueta",
    labelsCount_other: "{{count}} etiquetas",
    itemInfo: "Informações do item",
    selectCategoryToStart: "Selecione uma categoria para começar",
    selectCategoryToStartDesc:
      "Escolha uma categoria existente acima ou crie uma nova. Os campos do item e a tabela de etiquetas aparecerão aqui.",
    newCategoryDialogTitle: "Nova categoria",
    newCategoryDialogDesc:
      "Crie uma nova categoria para usar como modelo de impressão.",
    createCategory: "Criar categoria",
    descRequired: "Descrição",
    descPlaceholder: "Ex: Camiseta P Branca",
    codeRequired: "Código",
    codePlaceholder: "EAN ou código hexadecimal",
    cancel: "Cancelar",
    create: "Criar",
    repeatedEpcsFound: "EPCs repetidos encontrados",
    repeatedEpcsDesc:
      'Os EPCs abaixo já existem na base. Sincronize os dados e tente novamente, ou ative "Permitir repetidos" para imprimir mesmo assim.',
  },
  impressao: {
    verifyingTags: "Verificando etiquetas no campo antes de iniciar a ordem...",
    wait: "Aguarde",
    printerUnavailable: "Impressora não conectada ou indisponível.",
    tagNotFound: "Etiqueta não encontrada ou inválida.",
    noItemToReprint: "Nenhum item na fila para reimprimir.",
    noItemToRewrite: "Nenhum item na fila para regravar.",
    noZplToRewrite: "Etiqueta não possui ZPL para regravar.",
    usbNotReverseCompatible:
      "Impressão USB não é compatível com gravação reversa.",
    usbConnectionError:
      "Erro ao conectar com a impressora USB. Verifique a conexão.",
    usbPrintError: "Erro ao imprimir via USB: {{msg}}",
    legacyNotReverseCompatible:
      "Impressão Legacy não é compatível com gravação reversa.",
    finishedSuccess: "Impressão finalizada com sucesso!",
    statePrinted: "Impresso",
    stateSending: "Enviando",
    stateError: "Erro",
    stateWaiting: "Aguardando",
    estado: "Estado",
    pausedMsg: "Impressão pausada.",
    sendingMsg: "Suas etiquetas estão sendo enviadas para a impressora.",
    printError: "Erro na impressão",
    pausedTitle: "Impressão pausada",
    printingTitle: "Imprimindo etiquetas",
    followDesc: "Acompanhe o envio das suas etiquetas para a impressora.",
    close: "Fechar",
    tryAgain: "Tentar novamente",
    cancel: "Cancelar",
    resume: "Continuar",
    pause: "Pausar",
  },
  reimprimir: {
    syncSuccess: "Dados sincronizados com sucesso!",
    configNotFound:
      "Configurações de impressão não encontradas. Verifique as configurações e tente novamente.",
    informHardwareId:
      "Informe o Hardware ID nas configurações para realizar a impressão.",
    noItemSelected: "Nenhum item selecionado para reimprimir.",
    noZpl: "Item selecionado não possui ZPL para reimprimir.",
    generateError: "Erro ao gerar lista para impressão.",
    infoCompl: "Info. Complementar {{n}}",
    individualInfo: "Informação individual",
    qty: "Qtd:",
    val: "Val:",
    preview: "Pré-visualização",
    previewBtn: "Pré-visualizar",
    previewAlt: "Pré-visualização",
    openInNewTab: "Abrir em nova aba",
    zplUnavailable: "ZPL não disponível",
    actions: "Ações",
    details: "Detalhes",
    title: "Reimprimir Etiqueta",
    subtitle:
      "Busque uma etiqueta RFID já impressa e envie para a impressora novamente",
    sync: "Sincronizar",
    selectToReprint: "Selecione uma etiqueta para reimprimir",
    reprintThis: "Reimprimir esta etiqueta",
    reprint: "Reimprimir",
    searchLabel: "Buscar etiqueta",
    typeOrScan: "Digite ou escaneie o EPC...",
    clearEpc: "Limpar EPC",
    back: "Voltar",
    search: "Buscar",
    readWithModule: "Ler com módulo",
    readWithModuleHelp:
      "Aciona o leitor RFID conectado. A primeira tag detectada preenche o campo automaticamente e busca os dados na base.",
    itemsInBase: "Itens na base",
    ofTotal: "{{count}} de {{total}}",
    noItemFound: "Nenhum item encontrado.",
    noResultsFor: "Nenhum resultado para",
    selectedLabel: "Etiqueta selecionada",
    backToList: "Voltar para lista",
    locations: "Localizações",
    level: "Nível {{n}}",
    itemData: "Dados do item",
    description: "Descrição",
    labelTitle: "Etiqueta",
  },
  verificar: {
    labelRead: "Etiqueta lida",
    labelReadDesc: "Detalhes da etiqueta capturada pelo módulo de leitura.",
    searching: "Buscando etiqueta na base…",
    notFound: "Etiqueta não encontrada",
    notFoundDesc: "A etiqueta lida não foi localizada na base de dados.",
    epcRead: "EPC lido:",
    qty: "Qtd:",
    val: "Val:",
    locations: "Localizações",
    level1: "Nível 1",
    level2: "Nível 2",
    level3: "Nível 3",
    level4: "Nível 4",
    itemData: "Dados do item",
    description: "Descrição",
    infoCompl: "Info. Complementar {{n}}",
    preview: "Pré-visualização",
    open: "Abrir",
    previewAlt: "Pré-visualização da etiqueta",
    renderError: "Não foi possível renderizar a etiqueta.",
    renderedBy: "Renderização via labelary.com",
  },
  conferir: {
    rssi: "RSSI",
    antenna: "Antena",
    readings: "Leituras",
    notConnected: "Módulo não conectado. Verifique a conexão.",
    title: "Conferir Etiqueta",
    subtitle: "Leia etiquetas RFID em tempo real para conferência",
    connected: "Conectado",
    disconnected: "Desconectado",
    reader: "Leitor:",
    notDefined: "Não definido",
    startReading: "Iniciar Leitura",
    stopReading: "Parar Leitura",
    clear: "Limpar",
    totalTags: "Total de etiquetas",
    totalReadings: "Total de leituras",
    status: "Status",
    reading: "Lendo...",
    stopped: "Parado",
    readTags: "Etiquetas Lidas",
    tag: "etiqueta",
    tags: "etiquetas",
    noTagsRead: "Nenhuma etiqueta lida",
    noTagsReadDesc:
      'Clique em "Iniciar Leitura" e aproxime as etiquetas do leitor RFID.',
  },
  etiquetas: {
    configNotFound: "Configuração de impressão não encontrada.",
    updateSuccess: "Etiquetas atualizadas com sucesso!",
    updateError: "Erro ao atualizar etiquetas.",
    nameRequired: "Informe um nome para a etiqueta.",
    zplRequired: "Informe o ZPL da etiqueta.",
    name: "Nome",
    default: "Padrão",
    preview: "Pré-visualização",
    viewLabel: "Ver etiqueta",
    actions: "Ações",
    makeDefault: "Tornar padrão",
    edit: "Editar",
    cannotRemoveDefault: "Não é possível remover a etiqueta padrão",
    removeLabel: "Remover etiqueta",
    remove: "Remover",
    title: "Etiquetas",
    subtitle: "Gerencie os modelos de etiqueta (ZPL) do seu perfil de impressão",
    newLabel: "Nova etiqueta",
    registeredModels: "Modelos cadastrados",
    labelsCount_one: "{{count}} etiqueta",
    labelsCount_other: "{{count}} etiquetas",
    noLabels: "Nenhuma etiqueta cadastrada",
    noLabelsDesc:
      "Crie seu primeiro modelo de etiqueta ZPL para começar a imprimir.",
    editLabel: "Editar etiqueta",
    editDesc: "Atualize o nome ou o conteúdo ZPL da etiqueta.",
    newDesc: "Cadastre um novo modelo de etiqueta com seu código ZPL.",
    labelName: "Nome da etiqueta",
    labelNamePlaceholder: "Ex: Etiqueta padrão 100x50",
    zplCode: "Código ZPL",
    previewBtn: "Pré-visualizar",
    cancel: "Cancelar",
    saveChanges: "Salvar alterações",
    createLabel: "Criar etiqueta",
  },
  gravacao: {
    typeTag: "Digite uma tag para adicionar.",
    onlyHex: "A tag deve conter apenas caracteres hexadecimais (0-9, A-F).",
    alreadyAdded: "Esta tag já foi adicionada.",
    quantityPositive: "A quantidade deve ser maior que zero.",
    addAtLeastOne: "Adicione ao menos uma tag para gravar.",
    configNotFound: "Configuração de impressão não encontrada.",
    informHardwareId:
      "Informe o Hardware ID nas configurações para realizar a impressão.",
    singleEncoding: "Gravação avulsa",
    actions: "Ações",
    title: "Gravação Avulsa",
    subtitle: "Grave EPCs em tags RFID sem vínculo com itens",
    addTagsToWrite: "Adicione tags para gravar",
    writeNTags_one: "Gravar {{count}} tag",
    writeNTags_other: "Gravar {{count}} tags",
    write: "Gravar",
    manualTag: "Tag manual",
    add: "Adicionar",
    onlyHexHint: "Apenas caracteres hexadecimais (0-9, A-F).",
    generateRandom: "Gerar aleatórias",
    generate: "Gerar",
    generateRandomHint: "Gera EPCs válidos aleatórios para gravação.",
    tagsToWrite: "Tags para gravar",
    tag: "tag",
    tags: "tags",
    clear: "Limpar",
    noTagsAdded: "Nenhuma tag adicionada",
    noTagsAddedDesc:
      "Adicione tags manualmente ou gere aleatórias para começar.",
  },
  perfilModulo: {
    actions: "Ações",
    registeredProfiles: "Perfis cadastrados",
    profilesCount_one: "{{count}} perfil",
    profilesCount_other: "{{count}} perfis",
    configIdNotFound: "ID da configuração não encontrado.",
    makeDefault: "Tornar padrão",
    alreadyDefault: "Já é o perfil padrão",
    edit: "Editar",
    editName: "Editar nome",
    profileName: "Nome do perfil",
    typeProfileName: "Digite o nome do perfil",
    nameEmpty: "O nome do perfil não pode ficar vazio.",
    updateSuccess: "Perfil atualizado com sucesso!",
    editError: "Erro ao editar perfil.",
    invalidIdEdit: "ID ou conta inválidos para edição.",
    save: "Salvar",
    clone: "Clonar",
    cloneProfile: "Clonar perfil",
    newProfileName: "Nome do novo perfil",
    typeNewProfileName: "Digite o nome do novo perfil",
    cloneSuffix: "(cópia)",
    clonedProfileFallback: "Perfil clonado (cópia)",
    cloneSuccess: "Perfil clonado com sucesso!",
    cloneError: "Erro ao clonar perfil.",
    invalidIdClone: "ID ou conta inválidos para clonar.",
    delete: "Apagar",
    cannotDeleteDefault: "Não é possível apagar o perfil padrão",
    deleteProfile: "Apagar perfil",
    idAccountNotFound: "ID ou conta não encontrados.",
    deleteSuccess: "Perfil apagado com sucesso!",
    deleteError: "Erro ao apagar perfil.",
    createSuccess: "Novo perfil criado com sucesso!",
    createError: "Erro ao criar perfil.",
    editErrorRetry: "Erro ao editar perfil, tente novamente.",
    noName: "sem nome",
    multipleDefaultWarning:
      'Havia {{count}} perfis marcados como padrão. Mantivemos "{{nome}}" e desmarcamos os outros.',
    profile: "Perfil",
    default: "Padrão",
    deleteConfirm:
      'Tem certeza que deseja apagar o perfil "{{nome}}"? Esta ação não pode ser desfeita.',
    deleteConfirmGeneric:
      "Tem certeza que deseja apagar este perfil? Esta ação não pode ser desfeita.",
    deleteConfigTitle: "Apagar perfil de configuração",
    title: "Perfis de Configuração",
    subtitle: "Gerencie os perfis de configuração de impressão da conta",
    defaultLabel: " · padrão: ",
    newProfile: "Novo perfil",
    createProfile: "Criar perfil",
    noProfiles: "Nenhum perfil cadastrado",
    noProfilesDesc: "Crie um novo perfil pra começar a configurar a impressão.",
    createFirstProfile: "Criar primeiro perfil",
  },
  sscc: {
    quantity: "Quantidade",
    valueBrl: "Valor (R$)",
    validity: "Validade",
    assign: "Atribuir",
    noZplFound: "Nenhum ZPL encontrado",
    zplNotConfigured: "ZPL não configurado",
    view: "Visualizar",
    preview: "Pré-visualizar",
    previewAlt: "Pré-visualização",
    openInNewTab: "Abrir em nova aba",
    syncSuccess: "Dados sincronizados com sucesso!",
    selectCompany: "Selecione uma empresa para impressão.",
    configNotFound: "Configuração de impressão não encontrada.",
    informHardwareId:
      "Informe o Hardware ID nas configurações para realizar a impressão.",
    selectLocation: "Selecione uma localização para impressão.",
    errorCreatingCategory: "Erro ao criar categoria para a empresa selecionada.",
    noEpcGenerated: "Nenhum EPC gerado para impressão.",
    invalidEpcs:
      "EPCs inválidos encontrados. Verifique os dados e tente novamente.",
    individualInfoOptional: "Informação Individual (opcional)",
    individualInfo: "Informação individual",
    preview2: "Pré-visualização",
    allowRepeatedItems: "Permitir itens repetidos",
    company: "Empresa",
    locations: "Localizações",
    locationN1: "Localização Nv.1",
    locationN2: "Localização Nv.2",
    locationN3: "Localização Nv.3",
    locationN4: "Localização Nv.4",
    item: "Item",
    description: "Descrição",
    labels: "Etiquetas",
    repeatedEpcsTitle: "EPCs Repetidos Encontrados",
    repeatedEpcsDesc: "Os seguintes EPCs já existem na base de dados:",
    epcLabel: "EPC:",
    codeLabel: "Código:",
    syncToContinue: "Para continuar, sincronize e tente novamente",
    title: "Impressão SSCC",
    subtitle:
      "Gere e imprima códigos SSCC (Serial Shipping Container Code) por empresa",
    allowRepeated: "Permitir repetidos",
    selectCompanyLocationToPrint:
      "Selecione uma empresa e localização para imprimir",
    printNLabels_one: "Imprimir {{count}} etiqueta",
    printNLabels_other: "Imprimir {{count}} etiquetas",
    companyAndQuantity: "Empresa e quantidade",
    selectACompany: "Selecione uma empresa",
    level1: "Nível 1",
    level2: "Nível 2",
    level3: "Nível 3",
    level4: "Nível 4",
    generatedLabels: "Etiquetas geradas",
    labelsCount_one: "{{count}} etiqueta",
    labelsCount_other: "{{count}} etiquetas",
    selectCompanyToStart: "Selecione uma empresa para começar",
    ssccGeneratedByPrefix:
      "Os SSCCs serão gerados conforme o GS1 prefix da empresa escolhida.",
    repeatedEpcsFound: "EPCs repetidos encontrados",
    repeatedEpcsNewDesc:
      'Os EPCs abaixo já existem na base. Sincronize os dados e tente novamente, ou ative "Permitir repetidos" para imprimir mesmo assim.',
  },
  modulo: {
    noTagReadInTime:
      "Nenhuma etiqueta foi lida a tempo. Verifique se o módulo está conectado e tente novamente.",
    notDetected:
      "Parece que seu módulo não foi detectado. Verifique a conexão e tente novamente.",
    configNotFound: "Configuração de impressão não encontrada. ",
    configUpdated:
      "Configurações do módulo de impressão atualizadas com sucesso.",
    configUpdateError:
      "Erro ao atualizar configurações do módulo de impressão.",
    readings: "Leituras",
    dataTitle: "Dados do módulo",
    dataDesc: "Informações coletadas do hardware conectado.",
    status: "Status",
    available: "Disponível para impressão",
    busy: "Ocupado / indisponível",
    hardware: "Hardware",
    hardwareId: "Hardware ID",
    firmwareVersion: "Versão do firmware",
    wifiConnection: "Conexão Wi-Fi",
    network: "Rede",
    signalRssi: "Sinal (RSSI)",
    wifiMac: "MAC Wi-Fi",
    close: "Fechar",
    calibrationTitle: "Calibração do módulo",
    calibrationDesc:
      'Posicione a etiqueta na antena e clique em "Iniciar leitura" pra calibrar.',
    reading: "Lendo",
    detectedTags: "Etiquetas detectadas",
    tag: "etiqueta",
    tags: "etiquetas",
    clear: "Limpar",
    bringTagClose: "Aproxime uma etiqueta da antena…",
    noTagDetected: "Nenhuma etiqueta detectada ainda.",
    stopReading: "Parar leitura",
    startReading: "Iniciar leitura",
    stopBeforeClosing: "Pare a leitura antes de fechar",
    settingsTitle: "Configurações do módulo",
    settingsDesc: "Ajustes do hardware de impressão conectado.",
    identification: "Identificação",
    hardwareId1: "Hardware ID 1",
    readerSerial: "Serial do leitor",
    hardwareId2: "Hardware ID 2",
    alternative: "(alternativo)",
    optional: "Opcional",
    rfAndWriting: "RF e gravação",
    rfPower: "Força de RF",
    rfPowerTooltip:
      "Potência de RF aplicada ao gravar a etiqueta. Maior = mais alcance, mas pode gravar etiquetas próximas indesejadamente.",
    min: "Mín",
    max: "Máx",
    delayMs: "Atraso (ms)",
    attempts: "Tentativas",
    quickActions: "Ações rápidas",
    waitingResponse: "Aguardando resposta…",
    collectModuleInfo: "Coletar info do módulo",
    calibrate: "Calibrar",
    test: "Teste",
    defineHardwareIdForRoll: "Defina um Hardware ID para ajustar o rolo.",
    adjustRoll: "Ajustar rolo",
    onlyAdminsCanSave: "Apenas admins podem salvar",
    save: "Salvar",
  },
  mfa: {
    twoStepTitle: "Verificação em duas etapas",
    codeDialogDesc:
      "Digite o código de 6 dígitos gerado pelo seu aplicativo autenticador (ex.: Google Authenticator).",
    invalidCode: "Código inválido. Tente novamente.",
    cancel: "Cancelar",
    validating: "Validando...",
    signIn: "Entrar",
    step1:
      "Instale um aplicativo autenticador (ex.: Google Authenticator) no seu celular.",
    step2: "Escaneie o QR Code (ou informe a chave manual) no aplicativo.",
    step3: "Digite o código de 6 dígitos gerado para concluir a ativação.",
    enrollTitle: "Proteja sua conta com verificação em duas etapas",
    enrollDesc:
      "Recomendamos ativar a autenticação de múltiplos fatores (MFA) para aumentar a segurança da sua conta. A configuração é feita no portal iNOVACODE. Veja como:",
    dontAddNow: "Não adicionar agora",
    configureNow: "Configurar agora",
  },
};

export default pt;
export type TranslationResources = typeof pt;
